"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var ShowMoreButton = function ShowMoreButton(_ref) {
  var callback = _ref.callback,
      count = _ref.count;
  return (0, _preact.h)("span", {
    className: " show-more",
    onClick: callback
  }, (0, _preact.h)(_phrase.default, {
    p: "show.more",
    count: {
      number: count
    }
  }));
};

var _default = ShowMoreButton;
exports.default = _default;